import { useEffect, useState } from 'react'
import { useAssetParams } from '../../../hooks/useAssetParams'
import { Insight } from '../../Insights/Insight'
import { useOutletContext } from 'react-router-dom'
import ChartState from '../../Insights/ChartState'
import { loadFromSavedInsight } from '../../Objects/Insight/InsightAPI'
import { safeDecodeFromUrl } from '../../../utils'
import { merge } from 'lodash'
import styles from './SummaryAsset.module.scss'

// http://localhost:3000/asset/chart?fc7acca1-6381-4052-8aeb-d46d7e13e76c:W6:Omega105-012:true:eyJzdHlsZU92ZXJyaWRlcyI6eyJ0aXRsZSI6eyJ0ZXh0U3R5bGUiOnsiZm9udFNpemUiOjMyLjMwNzY5MjMwNzY5MjMxfX0sImxlZ2VuZCI6eyJzaG93Ijp0cnVlLCJ0ZXh0U3R5bGUiOnt9fX0sImNoYXJ0VGl0bGUiOiJPcHBvcnR1bml0eSBEaXN0cmlidXRpb24gYnkgU2FsZXMgU3RhZ2UiLCJ0aGVtZUlEIjoiVDE1MzciLCJzZWxlY3RlZEl0ZW1zIjpbeyJyZXBvcnRTZXJpZXNUYWJsZUlEIjoiSTIxNTIzXzIzNTg0MTgzMTciLCJrcGkiOiJOdW1iZXIgb2YgRGVhbHMgYnkgQ2xvc2UgRGF0ZSJ9XSwic2VsZWN0ZWREYXRlcyI6e30sInN0YWNrZWQiOnRydWUsInRhYmxlVGltZVNlcmllcyI6dHJ1ZSwiZHJpbGxBdHRyaWJ1dGUiOiJTdGFnZSIsImNhdGVnb3J5QXhpcyI6IlRpbWUiLCJzb3J0Q29sdW1ucyI6W3siY29sdW1uIjoiTnVtYmVyIG9mIERlYWxzIGJ5IENsb3NlIERhdGUiLCJvcmRlciI6ImRlc2MifV0sInBlcmlvZCI6Ik1vbnRobHkiLCJ0aW1lUmFuZ2UiOiJBbGwiLCJjYWxlbmRhclR5cGUiOiJDYWxlbmRhciIsInZpZXciOiJjaGFydCIsImRpc3BsYXlSb3dzIjoiQWxsIiwiZGlzYWJsZVRpbWVTZXJpZXMiOmZhbHNlLCJ1c2VkRHJpbGxBdHRyaWJ1dGVzIjpbXSwic2VyaWVzVHlwZSI6ImNvbHVtbiIsImtwaUNvbXBhcmVUeXBlIjoicGVyY2VudGFnZSIsImJhY2t3YXJkc0ZsYWciOiIyLjEuOCIsInRpdGxlIjoiT3Bwb3J0dW5pdHkgRGlzdHJpYnV0aW9uIGJ5IFNhbGVzIFN0YWdlIn0=

export const SummaryAsset = () => {
    const { params } = useAssetParams()
    const outletContext = useOutletContext()
    const [config, setConfig] = useState(ChartState.getDefaultConfig())
    const [theme, setTheme] = useState(null)
    const [chartState, setChartState] = useState(
        new ChartState(outletContext.server, config, setConfig)
    )

    useEffect(() => {
        if (params?.object) {
            //console.log('config', JSON.parse(safeDecodeFromUrl(params?.object)))
            const newConfig = merge(config, JSON.parse(safeDecodeFromUrl(params?.object)))
            loadFromSavedInsight(
                newConfig,
                setConfig,
                chartState,
                () => null,
                () => null,
                null,
                null,
                params.workspaceID,
                [],
                outletContext.workspaceMetadata,
                true
            )
            const themeID = newConfig.themeID
            if (!themeID || themeID === 'defaultTheme') {
                setTheme(undefined)
            } else {
                let theme = outletContext.workspaceMetadata.themes.find(
                    (t) => t.themeID === themeID
                )
                if (theme) {
                    setTheme(theme)
                } else {
                    // try fetching the theme
                    outletContext.server.postData(
                        {
                            action: 'getObject',
                            class: 'scoop.presentation.Theme',
                            key: themeID,
                        },
                        (r) => {
                            if (r) {
                                setTheme(r)
                            } else {
                                setTheme(undefined)
                            }
                        }
                    )
                }
            }
        }
    }, [params])

    //console.log(encodeChatObject(JSON.stringify(jsonObject), 'chart'))

    return (
        theme !== null && (
            <div id={'chat-screenshot-container'} className={styles.container}>
                <Insight
                    chartProperties={chartState}
                    setChartProperties={setChartState}
                    config={config}
                    setConfig={setConfig}
                    server={outletContext.server}
                    embeddedSizeProps={{
                        height: '100%',
                        width: '100%',
                        containerSize: outletContext.containerSize,
                    }}
                    activePrompts={[]}
                    workspaceMetadata={outletContext.workspaceMetadata}
                    theme={theme}
                    clickable={false}
                    slack
                />
            </div>
        )
    )
}
